import Paths from "./Paths";
import {IPath, ITalkie, Talkie} from "@dev/hc-talk-talk";
import {ILoginRequest, ILoginResponse} from "@/module/user";
import {EnvTypeEnum, IApplication} from "@/module/main";
import {EnvTypeEnum as EnvTypeForm} from "@/module/main/index";
import EnvType from "./EnvTypeEnum";
import LoginType from "@/module/api/service/LoginTypeEnum";
import ApiName from "@/module/api/service/ApiNameEnum";

class Api {
    private readonly apiClient: ITalkie;

    constructor() {
        this.apiClient = new Talkie();
    }

    public async login(request: ILoginRequest, envType: EnvTypeForm, env: string, loginUrlSuffix: LoginType): Promise<ILoginResponse | null> {
        let path: IPath = Paths.login;
        path.primaryBaseUrl = this.getBaseUrl(envType, env);
        path.slashParams = [envType === EnvTypeEnum.PROD ? "" : env, loginUrlSuffix];

        return await this.apiClient.post<ILoginRequest, ILoginResponse>(path, request);
    }

    public async createApplication<T>(
        request: T,
        envType: EnvTypeForm,
        env: string,
        apiName: ApiName,
        version: string): Promise<IApplication | null> {

        let path: IPath = envType == EnvTypeForm.PROD ? Paths.createApplicationProd : Paths.createApplication;
        path.primaryBaseUrl = this.getBaseUrl(envType, env);
        path.slashParams = [env, apiName, version];

        return await this.apiClient.post<T, IApplication>(path, request);
    }

    private getBaseUrl(envType: EnvTypeForm, env: string): string {
        let baseUrl: string = "";
        switch (envType) {
            case EnvTypeForm.TEST:
                baseUrl = EnvType[envType];
                break;
            case EnvTypeForm.PREPROD:
                baseUrl = env.startsWith("sk") ? EnvType.PREPROD_SK : EnvType.PREPROD_CZ;
                break;
            case EnvTypeForm.PROD:
                baseUrl = env == "sk" ? EnvType.PROD_SK : EnvType.PROD_CZ;
                break;
        }

        return baseUrl;
    }
}

export default new Api();
